import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Pattern } from '@app/shared/validators/pattern';
import { StoreContact, StoreDetail, StoreSocialMedia } from '../../models/store';
import { StoreService } from '../../services/store.service';
import { StoreCategory } from '../../models/storeCategory';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AddressService } from '@app/shared/services/address/address.service';
import { ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddStoreCategoryComponent } from '../store-category/add/add-store-category.component';
import { GetStoreInterface } from '@app/shared/services/common/getStoreList.interface';
import { type } from 'os';
@Component({
  selector: 'app-edit-store',
  templateUrl: './edit-store.component.html',
  styleUrls: ['./edit-store.component.css']
})
export class EditStoreComponent implements OnInit {

  editStoreForm: FormGroup;
  imageSrc !: any;
  public store = new StoreDetail();
  editStoreId !: any;
  storeCategories: StoreCategory[] = [];
  countries !: any[];
  states !: any[];
  userId !: any;
  storeCatId: any;
  w9Available: boolean = false;
  showNotification: boolean = false;
  @ViewChild('myInput') myInputVariable!: any;

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private storeService: StoreService,
    private activatedRoute: ActivatedRoute,
    private loader: LoaderService,
    private notificationService: NotificationService,
    private domSanitizer: DomSanitizer,
    private addressService: AddressService,
    private dialog: MatDialog) {

    // Accessing storeid from route params
    this.activatedRoute.params.subscribe(params => this.editStoreId = params);
    this.w9Available = false;
    this.editStoreForm = this.formBuilder.group({
      StoreName: new FormControl('', Validators.required),
      Description: new FormControl('', Validators.required),
      apiKey: new FormControl({ value: '', disabled: true }),
      StoreUrl: new FormControl({ value: '', disabled: true },
        Validators.compose([
          Validators.pattern('^[a-zA-Z0-9_]*$'),
          Validators.required
        ])),
      IsActive: new FormControl(false),  // Store status (ONLINE/OFFLINE)
      CanEndUserCustomize: new FormControl(false), // boolean, enable/disable option for end user to customize the published products
      StoreCategoryMappings: new FormControl(''),
      ContactPersonName: new FormControl(''),
      ContactNumber: new FormControl('',
        Validators.compose([
          Validators.pattern(Pattern.CONTACT_NO_PATTERN),
          Validators.minLength(10),
          Validators.maxLength(10)
        ])),
      ContactEmail: new FormControl('', Validators.pattern(Pattern.EMAIL_PATTERN)),
      AddressLine1: new FormControl(''),
      AddressLine2: new FormControl(''),
      PinCode: new FormControl('', Validators.pattern(Pattern.CONTACT_NO_PATTERN)),
      StateId: new FormControl(''),
      CountryId: new FormControl(''),
      City: new FormControl(''),
      Landmark: new FormControl(''),
      FacebookUrl: new FormControl(''),
      TwitterUrl: new FormControl(''),
      InstagramUrl: new FormControl(''),
      YouTubeUrl: new FormControl('')
    });
  }

  ngOnInit() {
    this.userId = localStorage.getItem('userId') !== null ? localStorage.getItem('userId') : '';
    this.getCountries();
    this.getStoreCategories();
    this.getStoreById(this.editStoreId.id);
  }

  ShowNotification() {
    if (!this.w9Available) {
      this.showNotification = true;
    }
  }

  mapStoreDetailsToStoreForm(storeDetail: GetStoreInterface) {
    //if (storeDetail.User.W9Details.pdfw9 != null) {
    //  this.w9Available = true;
    //  this.editStoreForm.controls['IsActive'].enable();
    //}
    //else {
    //  this.w9Available = false;
    //  this.editStoreForm.controls['IsActive'].disable();
    //}
    const defaultObj = this.editStoreForm.getRawValue();
    let newObj: any = { ...storeDetail, apiKey: storeDetail.apikey };
    if (newObj.StoreSocialMedia) {
      delete newObj.StoreSocialMedia.IsActive;
      newObj = { ...newObj, ...newObj.StoreSocialMedia };
    }
    if (newObj.StoreContact) {
      delete newObj.StoreContact.IsActive;
      newObj = { ...newObj, ...newObj.StoreContact };
    }
    newObj.StoreCategoryMappings = storeDetail.StoreCategoryMappings[0].StoreCategoryId;
    const cleanObj = {};
    Object.keys(defaultObj).forEach(value => {
      cleanObj[value] = newObj[value] ? newObj[value] : defaultObj[value];
    });
    return cleanObj;
  }

  // Gets store data by storeid
  getStoreById(storeId: string) {
    // this.loader.show();

    this.storeService.getStoreById(storeId).subscribe((res) => {
      if (res.StatusCode == 200) {
        if (res.Data.ResponseData.StoreContact !== null && res.Data.ResponseData.StoreContact !== '') {
          this.getStatesByCountry(res.Data.ResponseData.StoreContact.CountryId);
        }
      } else if (res.StatusCode == 204) {
        this.notificationService.info(res.Message, 'Info');
      }


      this.editStoreForm.setValue(this.mapStoreDetailsToStoreForm(res.Data.ResponseData));
      this.loader.hide();
    }, (err: any) => {
      this.notificationService.error('An error occured', 'Error');
      this.router.navigate(['store/list']);
      this.loader.hide();
    });
  }



  getStoreCategories() {
    try {
      this.storeService.getStoreCategories()
        .subscribe((res: any) => {
          this.storeCategories = res['Data']['ResponseData'];
        }, err => {
          this.loader.hide();
        });
    } catch (error) { }
  }

  fn_AddCategory() {
    const dialogRef = this.dialog.open(AddStoreCategoryComponent, {
      disableClose: true,
      height: '200px',
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      // If successfully created a category than it will be true, else false
      if (data != null) {
        this.storeCatId = data;
        this.getStoreCategories();
      }
    });
  }


  mapStoreFormToStoreDetails(): StoreDetail {
    const storeForm = this.editStoreForm.getRawValue();
    const storeDetails = new StoreDetail();
    Object.keys(storeDetails).forEach(value => {
      if (typeof storeDetails[value] !== 'object') {
        storeDetails[value] = storeForm[value] ? storeForm[value] : storeDetails[value];
      }
      if (value === 'StoreCategoryMappings') {
        storeDetails[value] = storeForm[value] ? [storeForm[value]] : [];
      }
    });
    Object.keys(storeDetails.StoreSocialMedia).forEach(value => {
      storeDetails.StoreContact[value] = storeForm[value] ? storeForm[value] : '';
    });
    Object.keys(storeDetails.StoreContact).forEach(value => {
      storeDetails.StoreContact[value] = storeForm[value] ? storeForm[value] : '';
    });
    storeDetails.UserId = this.userId;
    storeDetails.StoreId = this.editStoreId.id;
    return storeDetails;
  }
  UpdateStore(form: FormGroup) {
    this.loader.show();
    this.storeService.updateStore(this.mapStoreFormToStoreDetails()).subscribe((res) => {
      if (res.StatusCode === 200) {
        this.notificationService.success('Updated Sucessfully', 'Store');
        this.loader.hide();
      } else if (res.StatusCode === 500) {
        this.notificationService.error('An error occured', 'Try again');
        this.loader.hide();
      } else {
        this.loader.hide();
      }
    }, err => {
      this.notificationService.error('An error occured', 'Error');
      this.loader.hide();
    });
  }


  /** Get all countries */
  getCountries() {
    this.addressService.getCountries().subscribe((res: any) => {
      this.countries = res.Data.ResponseData;
    }, err => {
    });
  }

  /** Get states by country */
  getStatesByCountry(event: any) {
    this.loader.show();
    this.addressService.getStatesByCountry(event).subscribe((res: any) => {
      this.states = res.Data.ResponseData;
      this.loader.hide();
    }, err => {
      this.loader.hide();
    });
  }
}
